<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="'Profile'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
    <hr class="mt-3 horizontal dark" />

    <button @click="logout" class="button button-4 logoutButton" style="">
      Logout
    </button>
  </div>
</template>

<style scoped>
.logoutButton {
  position: fixed;
  bottom: 10px;
  width: auto;
  left: 20%;
  border-radius: 15px;
  border: 3px solid rgb(163, 44, 44);
  color: rgb(163, 44, 44);
  width: 150px !important;
}
</style>


<script>
import SidenavItem from "./SidenavItem.vue";
import { SetStoreLoginedValues } from "@/customFunctions/Auth.js";

export default {
  name: "SidenavList",
  props: {},
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      SetStoreLoginedValues(this.$store, false, this.$router);
    },
  },
};
</script>
